<template>
  <div class="gs-app gv-video-settings-panel">
    <div v-if="youtubeAccounts && youtubeAccounts.length === 0">
      <div class="w-full flex py-8 px-6 videoEncoder">
        <div
          class="
            w-full
            flex flex-col flex-nowrap
            items-center
            justify-center
          "
        >
          <div
            class="
              w-24
              h-24
              rounded-full
              bg-grey-300
              flex
              items-center
              justify-center
              m-auto
            "
          >
            <img
              style="max-width: 175% !important"
              src="../../assets/images/videos/Youtube-settings.png"
              alt="Youtube-settings"
            />
          </div>
          <h3 class="mt-6 mb-2">
            {{
              $t(
                'frontend_groovevideo_members_settings_index_lets_setup_youtube'
              )
            }}
          </h3>
          <p class="text-sm mb-3 text-grey-500 text-center w-2/5">
            {{
              $t(
                'frontend_groovevideo_members_settings_index_youtube_info'
              )
            }}
          </p>
          <div
            class="
              flex flex-row
              justify-center
              items-center
              border-grey-300 border border-solid
              cursor-pointer
              youtubeBtnBox
              text-custom-dark
              py-2
            "
            @click="loginGoogle"
          >
            {{
              $t('frontend_groovevideo_connect_with_youtube')
            }}
            <youtube-icon class="ml-2"/>
          </div>
          <p class="text-sm text-grey-500 mt-4">
            {{
              $t(
                'frontend_groovevideo_members_settings_index_need_help_connecting_youtube'
              )
            }}
            <a href="#" class="text-pink">
              {{
                $t(
                  'frontend_groovevideo_members_settings_index_visit_help_center'
                )
              }}
            </a>
          </p>
        </div>
      </div>
    </div>

    
    <div v-else>
      <div
        v-if="youtubeAccounts.length >= 1"
        class="flex flex-row justify-end w-full"
      >
        <div class="text-right px-6 mt-2">
          <gs-button
            size="md"
            variant="primary"
            @click="loginGoogle()"
          >
            {{
              $t('frontend_groovevideo_members_settings_index_add_youtube_account')
            }}
          </gs-button>
        </div>
      </div>
      <div>
        <div
          class="flex flex-wrap w-full "
        >
          <info-panel
            v-for="(youtube, youtubeIndex) in youtubeAccounts"
            :key="youtubeIndex"
            class="my-4 mx-2 storage-section relative"
          >
            <template slot="content">
              <div class="w-full h-full flex items-center justify-center p-4">
                <img
                  src="@/assets/images/logo/Youtube.png"
                  alt="content-img"
                  class="responsive h-auto mx-auto"
                />
              </div>
            </template>
            <template slot="footer">
              <div class="flex w-full my-auto px-4 py-3 justify-between">
                <div class="flex flex-row h-6">
                  <div
                    class="text-sm text-black font-semibold capitalize"
                  >
                    {{ youtube.channel_name }}
                  </div>
                  <div
                      v-if="!youtube.access_token"
                      class="ml-1"
                      v-tooltip.bottom="{
                          content: $t(
                          'frontend_groovevideo_select_yt_account_logged_out'
                          ),
                          classes: 'groovevideo-videos-tooltip',
                          delay: {
                          show: 200,
                          hide: 200,
                          },
                      }"
                  >
                      <warning-icon />
                  </div>
                </div>
                <div
                  class="text-grey-700 cursor-pointer"
                  @click="deleteYoutube(youtube.id)"
                >
                <i class="fas fa-trash" />
                </div>
              </div>
            </template>
          </info-panel>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import youtubeIcon from '@/assets/images/icons/YouTube.svg';
import warningIcon from '@/assets/images/icons/warning.svg';
import YoutubeApiSettings from '@/models/YoutubeApiSettings.js';

export default {
  props: {
    youtubeAccounts: {
      required: true,
    }, 
  },
  components: {
    youtubeIcon,
    warningIcon,
  },
  data () {
    return {
      google: null,
      client: null
    };
  },
  mounted () {
    // setup youtube client
    this.$nextTick(() => {
        setTimeout(() => {
          this.google = window.google;
          this.setupYoutubeClient();
        }, 1000);
    });
  },

  methods: {
    setupYoutubeClient() {
        this.client = this.google.accounts.oauth2.initCodeClient({
          client_id: this.$store.getters.youtubeApiClientId,
          scope: 'https://www.googleapis.com/auth/youtube.force-ssl',
          ux_mode: 'popup',
          callback: async (response) => {
            this.$emit('setIsLoading', true);
            axios.post('youtube-auth', response).then((resp) => {
              if (
                typeof resp.data !== 'undefined' &&
                typeof resp.status !== 'undefined' &&
                resp.status !== 202
              ) {
                const settingIds = this.youtubeAccounts.map(el => el.id);           
                if (!settingIds.includes(resp.data.data.id)) {
                  this.youtubeAccounts.push(resp.data.data);
                } else {
                  Swal.fire(this.$t('frontend_groovevideo_warning_title'), this.$t('frontend_groovevideo_select_yt_account_account_exists'), 'warning');
                }
              } else {
                Swal.fire(this.$t('frontend_error'), resp.data.message, 'warning');
              }
              this.$emit('setIsLoading', false);
            });
          },
        });
      },
    loginGoogle () {
      this.client.requestCode();
    },

    async deleteYoutube (id) {
      const { value: accept } = await Swal.fire({
        title: this.$t('frontend_sure'),
        text: this.$t('frontend_non_revertable'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('frontend_delete_confirm'),
      });
      
      if (accept) {
        this.$emit('setIsLoading', true);
        const youtube = await YoutubeApiSettings.$find(id);
        const response = await youtube.delete();

        if (
          typeof response.data !== 'undefined' &&
          typeof response.data.status !== 'undefined' &&
          response.data.status == true
        ) {
            const deletedYoutube = this.youtubeAccounts.findIndex(el => el.id === id);
            this.youtubeAccounts.splice(deletedYoutube, 1);
        } else {
          Swal.fire( this.$t('frontend_groovevideo_warning_title'), response.data.message, 'warning' ); 
        }
        this.$emit('setIsLoading', false);
      }
    },
  }
};
</script>
<style>
.videoEncoder h3 {
  font-size: 20px !important;
  color: #191d3a;
}
.storage-section {
  width: 23.5% !important;
  height: 267px !important;
  min-width: 250px !important;
}
.storage-section .rounded-md-top {
  border-radius: 4px 4px 0px 0px !important;
}
.youtubeBtnBox div {
  width: 220px;
  height: 32px;
  border-radius: 5px;
}
</style>

<style>
.gv-video-settings-panel .videoEncoder { padding: 24px; border: 1px solid var(--gs-border); border-radius: var(--gs-radius-lg); background: var(--gs-surface-subtle); }
.gv-video-settings-panel .storage-section { border: 1px solid var(--gs-border); border-radius: var(--gs-radius-lg); box-shadow: var(--gs-shadow-sm); }
@media (max-width: 640px) { .gv-video-settings-panel .videoEncoder { padding: 16px; } .gv-video-settings-panel .videoEncoder .w-2\/5 { width: 100% !important; } }
</style>
